var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.668 2.25a.75.75 0 0 1 0 1.5 3.917 3.917 0 1 0 3.916 3.917.75.75 0 0 1 1.5 0 5.4 5.4 0 0 1-1.094 3.262l2.208 2.208.051.056a.75.75 0 0 1-1.055 1.055l-.056-.05-2.208-2.209a5.417 5.417 0 1 1-3.262-9.74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.113 2.598a.235.235 0 0 1 .442 0c.29.783.435 1.175.72 1.46.286.286.678.431 1.461.721a.235.235 0 0 1 0 .442c-.783.29-1.175.435-1.46.72-.286.286-.431.678-.721 1.461a.235.235 0 0 1-.442 0c-.29-.783-.435-1.175-.72-1.46-.286-.286-.678-.431-1.461-.721a.235.235 0 0 1 0-.442c.783-.29 1.175-.435 1.46-.72.286-.286.431-.678.721-1.461"
  })));
};
export default Svg16;